<script>
import ArrowSVG from '@/static/svg/arrow.svg';

export default {
  name: 'Button',
  components: {
    ArrowSVG,
  },
  props: {
    color: {
      type: String,
      default: "#31CAAF",
    },
    opacity: {
      type: Number,
      default: 0.5,
    }
  },
  data() {
    return {
      clicked: false,
    }
  },
  methods: {
    click() {
      if(this.clicked) return;

      this.$store.commit('App/ENABLE_NO_SLEEP');

      this.$store.dispatch('Sound/PLAY', {id: 'tic'});
      this.$emit('pressed');
      this.clicked = true;
    },
  }
}
</script>

<template>
  <div class="Button">
    <a class='a' href="#" @click.prevent="click" ref="Btn">
      <ArrowSVG class='icon' :style="{
        fill: color,
        opacity: opacity,
      }" />
    </a>
  </div>
</template>

<style scoped lang="scss">

.Button{
  display: block;
  width: 100%;
  cursor: pointer;
}

.a {
  display: block;
  width: 100%;
}

.icon {
  width: 100%;
  height: auto;
}
</style>
